const departureCity = [
  { value: "Warsaw", label: "Warsaw" },
  { value: "Katowice", label: "Katowice" },
  { value: "Gdansk", label: "Gdansk" },
  { value: "Krakow", label: "Kraków" },
  { value: "Wroclaw", label: "Wrocław" },
  { value: "Poznan", label: "Poznań" },
  { value: "Rzeszow", label: "Rzeszów" },
  { value: "Bydgoszcz", label: "Bydgoszcz" },
  { value: "Lodz", label: "Łodz" },
  { value: "zielona_gora", label: "Zielona Gora" },
  { value: "Olsztyn", label: "Olsztyn" },
  { value: "Radom", label: "Radom" },
  { value: "Lublin", label: "Lublin" },
];

export default departureCity;
